import { render, staticRenderFns } from "./expert-review-loader.vue?vue&type=template&id=d431f858&scoped=true"
import script from "./expert-review-loader.vue?vue&type=script&lang=js"
export * from "./expert-review-loader.vue?vue&type=script&lang=js"
import style0 from "./expert-review-loader.vue?vue&type=style&index=0&id=d431f858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d431f858",
  null
  
)

export default component.exports